<template>
    <div>
      <guide-share-header :wxa-page="wxaPage" :wxa-page-param="wxaPageParam" :name="shareHaderName"></guide-share-header>
          <div class="guide-page-right">

        <div class="common-title">
            <div class="common-title-content">寄送资料</div>
            <div class="common-title-sub">如订单有纸质资料需要寄送，系统提供两种方式寄送快递，1、通过系统下单顺丰上门取件。您可根据资料准备的情况在支付前或支付后选择顺丰上门取件；2、自行邮寄。若无需顺丰上门取件，您亦可选择自行邮寄，邮寄后在官网填写快递信息即可。</div>
        </div>

        <div class="line-title">

            <div class="line-title-content">顺丰上门取件</div>

        </div>

         <div class="step-box">

            <div class="step-title">
                <div class="step-title-number">01</div>
                <div class="step-title-content">支付前选择顺丰上门取件，勾选「顺丰上门取资料服务」，选择「寄件地址」，订单支付后等待顺丰上门取件即可；</div>
            </div>

            <div class="step-subtitle"></div>

            <div class="step-content">
                 <img v-bind:src="imageBaseUrl + imageIndex[0]" alt="">
            </div>

        </div>

        <div class="step-box">

            <div class="step-title">
                <div class="step-title-number">02</div>
                <div class="step-title-content">支付后选择顺丰上门取资料服务：点击「寄送资料」，选择「顺丰上门取资料」，选择「寄件地址」，支付订单即可；</div>
            </div>

            <div class="step-subtitle"></div>

            <div class="step-content">
                <img v-bind:src="imageBaseUrl + imageIndex[1]" alt="">
                <img v-bind:src="imageBaseUrl + imageIndex[2]" alt="">
                <img v-bind:src="imageBaseUrl + imageIndex[3]" alt="">
            </div>

        </div>

        <div class="line-title">

            <div class="line-title-content">自行邮寄</div>

        </div>

        <div class="step-box">

            <div class="step-title">
                <div class="step-title-number">01</div>
                <div class="step-title-content">点击「寄送资料」，选择「自行邮寄」，填写快递信息即可；</div>
            </div>

            <div class="step-subtitle"></div>

            <div class="step-content">
                <img v-bind:src="imageBaseUrl + imageIndex[4]" alt="">
                <img v-bind:src="imageBaseUrl + imageIndex[5]" alt="">
            </div>

        </div>


    </div>
    </div>
</template>

<script>
import sensorsdata from 'sa-sdk-javascript';
import GuideShareHeader from '../component/GuideShareHeader';

export default {
  name: 'MailMaterial',
  components: {
    GuideShareHeader,
  },
  data() {
    return {
      wxaPage: '',
      wxaPageParam: '',
      shareHaderName: '寄送资料',
      imageBaseUrl: 'https://o.666visa.cn/static/common/guides/',
      imageIndex: [
        '10_01.png',
        '10_02.png',
        '10_03.png',
        '10_04.png',
        '10_05.png',
        '10_06.png',
      ],
    };
  },
  mounted() {
    sensorsdata.track('UserGuide', {
      guide_name: '寄送资料',
    });
  },
};
</script>
<style lang=less>
@import "../../../assets/less/guide.less";
.guide-page-right {
  padding: 30px 70px 30px 70px;
}
</style>



// WEBPACK FOOTER //
// src/pages/guide/sub/mailMaterial.vue